module.exports = {
  FEATURE: 'feature',
  SMART: 'smart',
  DESKTOP: 'desktop',
  CONSOLE: 'console',
  PORTABLE: 'portable',
};
